/*
 * Copyright (c) 2020. American Express Company
 */

import { applyMiddleware, compose, createStore } from 'redux';
import rootReducer from './reducers';
import thunk from 'redux-thunk';

export const REDUX_STORAGE_KEY = 'bw-state';

const safeStringify = (obj: Object): string => {
    const cache: any[] = [];

    return JSON.stringify(obj, (key: string, value: any) => {
        if (typeof value === 'object' && value !== null) {
            if (cache.includes(value)) {
                // Circular reference found, discard key
                return;
            }
            // Store value in our collection
            cache.push(value);
        }
        return value;
    });
};

const saveToStorage = (state: any): void => {
    const serializedState = safeStringify(state);
    sessionStorage.setItem(REDUX_STORAGE_KEY, serializedState);
};

const loadFromStorage = (): any => {
    if (typeof window !== 'undefined') {
        const serializedState = sessionStorage.getItem(REDUX_STORAGE_KEY);
        if (serializedState === null) return undefined;
        return JSON.parse(serializedState);
    }
};

const persistedState = loadFromStorage();

const store = createStore(rootReducer, persistedState, compose(applyMiddleware(thunk)));

store.subscribe(() => saveToStorage(store.getState()));

export default store;
